module.exports = __webpack_public_path__ + "res/30-img_timer.9bcafc933051ac834100f53704721a65.png";